import { render, staticRenderFns } from "./ArtworkActionDetails.vue?vue&type=template&id=4f772ee0"
import script from "./ArtworkActionDetails.vue?vue&type=script&lang=js"
export * from "./ArtworkActionDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports